import DecorativeEllipse from "@/components/DecorativeEllipse";

export default function CtaSection() {
  return (
    <section className="relative overflow-hidden" style={{ backgroundColor: "#141414" }}>
      {/* Decorative ellipses */}
      <DecorativeEllipse
        className="-top-40 left-1/2 -translate-x-1/2"
        size={600}
        opacity={0.08}
        blur={150}
      />
      <DecorativeEllipse
        className="-bottom-48 left-1/4"
        size={400}
        opacity={0.05}
        blur={120}
      />

      {/* Gold gradient radial overlay */}
      <div className="absolute inset-0 bg-gradient-radial from-gold/[0.04] via-transparent to-transparent pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gold/[0.02] to-transparent pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 py-16 md:py-24 text-center">
        <p className="font-sans text-sm md:text-base text-gold-muted mb-6 tracking-wide uppercase">
          Aquí no hay magia. Hay habilidades, guiones, seguimiento y decisiones.
        </p>
        <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl text-cream mb-8 leading-snug">
          La diferencia entre quienes atraen oportunidades y quienes las esperan no es talento.
          <br />
          <span className="text-gold">Es un sistema.</span>
        </h2>

        <a
          href="#pricing"
          className="inline-flex items-center justify-center gap-3 px-8 py-4 md:px-10 md:py-5 rounded-md font-sans font-semibold text-base md:text-lg text-white transition-all duration-300 hover:scale-[1.02] hover:brightness-110"
          style={{ backgroundColor: "#2E7D32" }}
        >
          <span>Quiero acceso ahora</span>
          <i className="ri-arrow-right-line text-lg" />
        </a>
      </div>
      {/* Divider */}
      <div className="relative z-10 h-px bg-gold-gradient" />
    </section>
  );
}